var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"is-fullwidth",attrs:{"type":"is-dark","size":"is-medium","icon-left":"user-plus"}},[_vm._v("Registrarse")])}
var staticRenderFns = []

export { render, staticRenderFns }